import {
  LazyQueryHookOptions,
  OperationVariables,
  QueryTuple,
  useLazyQuery as useApolloLazyQuery,
} from '@apollo/client';
import { DocumentNode } from 'apollo-link/lib/types';

import { useGraphQLErrorHandler } from '@sbu/hooks.graphqlerrorhandler';

type QueryOptions = {
  notifyErrors?: boolean;
};

export function useLazyQuery<
  TData = any,
  TVariables extends OperationVariables = OperationVariables
>(
  query: DocumentNode,
  options?: LazyQueryHookOptions<TData, TVariables> & QueryOptions
): QueryTuple<TData, TVariables> {
  const { notifyErrors = true } = options || {};
  const [executeQuery, result] = useApolloLazyQuery<TData, TVariables>(query, {
    errorPolicy: 'all',
    ...(options || {}),
  });

  useGraphQLErrorHandler({
    error: result.error,
    loading: result.loading,
    notifyErrors,
  });

  return [executeQuery, result] as QueryTuple<TData, TVariables>;
}
